let modalCount = 0;
let maxLayer = 0;

export const acquireModalLayer = () => {
  modalCount += 1;
  maxLayer = modalCount;
  document.body.dataset.maxModalLayer = maxLayer;
  document.body.style.overflow = "hidden";
  return maxLayer;
};

export const releaseModalLayer = () => {
  modalCount = Math.max(0, modalCount - 1);
  maxLayer = modalCount;
  document.body.dataset.maxModalLayer = maxLayer;

  if (modalCount === 0) {
    document.body.style.overflow = "unset";
  }
};

export const getCurrentMaxLayer = () => maxLayer;
